export enum TransactionTypeEnum {
    WITHDRAWAL = "WITHDRAWAL",
    DEPOSIT = "DEPOSIT"
}

export const PositiveTransactionType: TransactionTypeEnum[] = [
    TransactionTypeEnum.DEPOSIT
] 